import Image from 'next/image';
const OfferCard = () => {
  return (
    <div className=" max-w-[300px] 2xl:max-w-[415px] mx-auto rounded-lg relative">
      <div className="relative">
        <Image
          src="/images/popup.svg" 
          alt="Discount Offer"
          width={415}
          height={221}
          className="rounded-lg mx-auto"
        />
      </div>
      <div className="mt-4 px-2">
        <p className=" text-[18px] lg:text-[22px] text-black font-medium">
        Boost Your SEO with W3era App!        </p>
        <p className='text-textGrey text-[14px]'>
        Access powerful tools for smarter, faster optimization
        , all in one dashboard.  </p>
      
      </div>
     
    </div>
  );
};

export default OfferCard;
